import { useNavigate } from "react-router-dom";

import { ImageIcons } from "components";

const MyBooksHeader = () => {
    const navigate = useNavigate();

    return (
        <div
            style={{
                width: "100%",
                height: "80px",
                opacity: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "0 16px",
                backgroundColor: "#FFFFFF",
            }}
        >
            <div style={{ display: "flex", alignItems: "center" }}>
                <div
                    onClick={() => navigate(-1)}
                    style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "8px",
                        marginLeft: "-8px",
                    }}
                >
                    <svg
                        width="8"
                        height="14"
                        viewBox="0 0 7 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M6 1L1 6L6 11"
                            stroke="#000000"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>

                <h1
                    style={{
                        fontWeight: 600,
                        fontSize: "18px",
                        lineHeight: "27.32px",
                        letterSpacing: "0%",
                        color: "#000000",
                        margin: 0,
                        marginLeft: "16px",
                    }}
                >
                    My Books
                </h1>
            </div>

            <div style={{ width: "100px", height: "auto" }}>
                <ImageIcons name="Logo" alt="fruitX-logo" style={{ width: "100%", height: "auto" }} />
            </div>
        </div>
    );
};

export default MyBooksHeader;
